import {
  CloseRounded,
  RadioButtonUncheckedRounded,
  Add,
  Delete,
  BorderColor,
  PermContactCalendar,
  Business,
  PeopleAlt,
  ContactMail,
  ArrowBackIosNewRounded,
  ArrowForwardIosRounded,
  Info,
  SimCardDownload,
  Send,
} from '@mui/icons-material'
import { createTheme } from '@mui/material'

export const colors = {
  PRIMARY_COLOR: '#14b7ae',
  SECONDARY_COLOR: '#05a8ff',
  WARNING_COLOR: '#FF4800',
  GREY_COLOR: '#E9E8E8',
  MAD_BLACK: '#686464',

  WEEK: {
    SUN_COLOR: '#E12639',
    SAT_COLOR: '#2C70D2',
    SUN_BG_COLOR: '#FDF4F5',
    SAT_BG_COLOR: '#EAF1FA',
  },
}

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: colors.PRIMARY_COLOR,
      light: colors.PRIMARY_COLOR,
      dark: colors.PRIMARY_COLOR,
      contrastText: '#ffffff',
    },
    secondary: {
      main: colors.PRIMARY_COLOR,
    },
    warning: {
      main: '#ff4800',
    },
    error: {
      main: '#ff005a',
    },
    action: {
      hover: '#edebeb',
    },
  },
  typography: {
    fontSize: 12,
    body1: {
      fontSize: '14px',
      color: '#333333',
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#00000099',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: '6px 8px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '6px 8px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '8px 8px',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '0 0 10px',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          margin: 0,
          gap: '4px',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          [`& .MuiOutlinedInput-root`]: {
            paddingTop: '0 !important',
            paddingBottom: '0 !important',
            paddingLeft: '0 !important',
          },
        },
        input: {
          minHeight: '30px',
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'negative' },
          style: {
            color: 'white',
            backgroundColor: '#DFE2E2',
            boxShadow: '1px 1px 2px 0px #00000040',
            '&:hover': {
              backgroundColor: '#DFE2E292',
            },
          },
        },
        {
          props: { variant: 'outlined' },
          style: {
            borderColor: 'currentColor',
            backgroundColor: 'white',
            color: '#5F6E6E',
            boxShadow: '1px 1px 2px 0px #00000040',
            '&:hover': {
              backgroundColor: 'white',
            },
          },
        },
      ],
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          fontSize: '14px',
          padding: '0 8px',
          '&.Mui-disabled': {
            color: 'white',
            backgroundColor: '#DFE2E2',
          },
        },
      },
    },
  },
})

export const Icons = {
  addButton: Add,
  deleteButton: Delete,
  closeButton: CloseRounded,
  editButton: BorderColor,
  leftButton: ArrowBackIosNewRounded,
  rightButton: ArrowForwardIosRounded,
  sendMail: ContactMail,
  sendShift: Send,
  autoAssign: PermContactCalendar,
  securityField: Business,
  security: PeopleAlt,
  answerOk: RadioButtonUncheckedRounded,
  answerNg: CloseRounded,
  warning: Info,
  csvDownload: SimCardDownload,
}

// variableを拡張
declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    negative: true
  }
}
